import {
  DeadlineItemHeader,
  DeadlineMonth,
  getMonthName,
  getShortDayName,
} from '@/features/dashboard/components/Deadlines'
import { CardSubtitle, CardTitle } from '@/components/Card'
import { AutoSkeleton, useIsSkeleton } from '@/components/Skeleton'

const deadLine = {
  date: { year: 2026, month: 3, day: 16 },
  description: 'S corporations and partnerships filing deadline.',
}

interface JobWidgetDeadlineProps {
  title: string
  subtitle?: string
  isSkeleton?: boolean
}

export function JobWidgetDeadline({
  title,
  subtitle,
  isSkeleton,
}: JobWidgetDeadlineProps) {
  const { year, month, day } = deadLine.date
  const dayName = getShortDayName(year, month, day)
  isSkeleton = useIsSkeleton(isSkeleton)

  return (
    <AutoSkeleton isSkeleton={isSkeleton}>
      <DeadlineMonth title={`${getMonthName(year, month)}`}>
        <DeadlineItemHeader day={dayName} date={day}>
          <div>
            <CardTitle>{title}</CardTitle>
            <CardSubtitle>{subtitle}</CardSubtitle>
          </div>
        </DeadlineItemHeader>
      </DeadlineMonth>
    </AutoSkeleton>
  )
}
